<template>
    <div>
        <div class="craft">
            <div class="part-one">
                <div class="base-title">
                    <div class="part-one-content">
                        <img class="part-one-title-img" src="../assets/imgs/craft/part-1-title.png" alt="" />
                        <div class="part-text part-one-text">
                            围绕实施产业建圈强链行动,创新实施“成都市产业建圈强链人才计划”,充分发挥重点产业链链主企业等市场主体作用,引导优质项目、人才资源、创新要素向重点产业链加速汇聚,推动创新链、产业链、资金链、人才链深度融合。
                        </div>
                    </div>
                </div>
            </div>
            <div class="part-two">
                <img src="../assets/imgs/10/title1.png" class="part-two-title-img" />
                <div class="part-text">
                    “成都市产业建圈强链人才计划”支持范围为在我市集成电路、新型显示、智能终端、高端软件与操作系统、大数据与人工智能（含车载智能控制系统)、工业互联网、卫星互联网与卫星应用、金融科技、航空发动机、工业无人机、大飞机制造与服务、汽车（新能源汽车）、轨道交通、现代物流、生态环保、新能源、新材料、创新药（含中医药)、高端医疗器械、高端诊疗、旅游业、文创业（含数字文创)、会展业、体育产业、音乐产业、美食产业（含绿色食品）、现代种业、都市农业重点产业链工作，且研究方向符合各重点产业链产业发展方向的企业在职人员。
                </div>
            </div>
            <div class="part-two">
                <img src="../assets/imgs/10/title2.png" class="part-two-title-img" />
                <div class="part-text">
                    28个产业领军人才具体申报条件，详见各项目申报通知。
                </div>
            </div>
            <div class="part-three">
                <img src="../assets/imgs/10/title3.png" class="part-two-title-img" />
                <div class="part-three-items" v-for="item in part3" :key="item.id">
                    <img :src="item.title" class="part-three-items-img" />
                    <div class="part-three-items-text" :style="item.text ? item.text : ''">
                        {{ item.content }}
                    </div>
                </div>
            </div>
            <div class="part-three" style="padding-top: 1.5rem">

                <img src="../assets/imgs/10/title4.png" class="part-two-title-img" />
                <div class="part-title part-four-title" style="margin-bottom: 0.8rem">
                    印发申报通知
                </div>
                <div class="part-three-items" v-for="item in part4" :key="item.id" :style="item.boxHeight">
                    <img :src="item.title" class="part-three-items-img part-three-plus" />
                    <div class="part-four-texts" v-for="item2 in item.content" :key="item2.id"
                        style="margin-bottom: 0.22rem; position: relative">
                        <div :class="
                            item2.id === 7
                                ? 'part-two-dot2'
                                : 'part-two-dot'
                        ">
                            {{ item2.id }}
                        </div>
                        {{ item2.text }}
                    </div>
                </div>
            </div>
            <div class="part-five">
                <div class="code">
                    <img src="../assets/imgs/10/code2.png" class="scan-code" />
                    <img src="../assets/imgs/10/code2-text.png" style="width: 4.1rem; height: 1.59rem" />
                </div>
            </div>
            <div class="call">
                <div class="part-five-items" v-for="(item, index) in phoneNumber" :key="index" :style="{height:item.height}">
                    <a :href="`tel:` + `${item.number}`" style="text-decoration: none; font-weight: normal;font-size: 0.26rem;">{{
                        item.number }}</a>
                </div>
                <div class="mark">
                    <span style="font-weight: bolder">注:</span>
                    联系方式根据产业链及政策调整实时更新。
                </div>
            </div>
        </div>
        <call phone="028-61886095"></call>
    </div>
</template>

<script>
import call from "../components/call.vue";

export default {
    name: "craft",
    data() {
        return {
            part3: [
                {
                    id: 1,
                    title: require("../assets/imgs/10/part3-1.png"),
                    content: "为入选者提供30万元(分三年拨付，每年10万元)资助资金，主要用于科技研发、课题研究、交流培训、团队建设、成果转化、市场推广等。各区(市)县可结合实际给予适当配套经费支持。",
                },
                {
                    id: 2,
                    title: require("../assets/imgs/10/part3-2.png"),
                    content: "住房限购期间，入选者可不受户籍、社保缴纳时间限制，在成都市域范围内购买首套商品住房。入选者纳入《成都市人才分类目录》C类人才，符合安居资格的可优惠购买人才公寓，按规定享受政策面积优惠。",
                },
                {
                    id: 3,
                    title: require("../assets/imgs/10/part3-3.png"),
                    content: "入选者子女在我市接受义务教育的，由其子女户籍或居住地(户籍不在我市的)所在区(市)县教育行政部门统筹安排较好的公办学校就读;在我市参加中考的，同等条件下优先录取。",
                },
                {
                    id: 4,
                    title: require("../assets/imgs/10/part3-4.png"),
                    content:"定期选派入选者到国内外知名大学、研究机构和企业开展学习考察，优先支持入选者参加重要学术交流活动、赴外研修访问。在“成都蓉漂人才发展学院”开设“产业领军人才提升营”，定期组织入选者开展专班培训。"
                    ,text: "text-align: left;",
                },
                {
                    id: 5,
                    title: require("../assets/imgs/10/part3-5.png"),
                    content:"经市级及以上行业主管部门推荐，入选者在管理期内，可放宽学历、任职年限等条件，破格申报工程系列职称。鼓励所在单位选聘入选者担任首席科学家、首席研究员、首席工程师、首席技师等。"
                    ,text: "text-align: left;",
                },
                {
                    id: 6,
                    title: require("../assets/imgs/10/part3-6.png"),
                    content:"入选者每年可享受由市级有关部门组织的体检和疗养休假服务，也可享受所在区(市)县组织的相应疗养休假活动。",
                    text: "text-align: left;",
                },
                {
                    id: 7,
                    title: require("../assets/imgs/10/part3-7.png"),
                    content:"入选者纳入所在区(市)县高层次人才库，由区(市)县开展人才联系培养工作。入选者可申领“蓉城人才绿卡”区县卡，享受落户、医疗、创业扶持等服务保障。"
                    ,text: "text-align: left;",
                },
            ],
            part4: [
                {
                    id: 11,
                    title: require("../assets/imgs/10/part4-1.png"),
                    content: [
                        {
                            id: 1,
                            text: "企业申报；",
                        },
                        {
                            id: 2,
                            text: "确定自评企业；",
                        },
                        {
                            id: 3,
                            text: "企业开展自评；",
                        },
                        {
                            id: 4,
                            text: "产业链牵头市级部门初审；",
                        },
                        {
                            id: 5,
                            text: "市委组织部复审；",
                        },
                        {
                            id: 6,
                            text: "公示；",
                        },
                        {
                            id: 7,
                            text: "确定人选。",
                        },
                    ],
                    boxHeight: "height:5.61rem;padding-left:0.5rem",
                },
                {
                    id: 21,
                    title: require("../assets/imgs/10/part4-2.png"),
                    content: [
                        {
                            id: 1,
                            text: "成立评选委员会；",
                        },
                        {
                            id: 2,
                            text: "确定评选方案；",
                        },
                        {
                            id: 3,
                            text: "组织申报、评选；",
                        },
                        {
                            id: 4,
                            text: "产业链牵头市级部门初审；",
                        },
                        {
                            id: 5,
                            text: "市委组织部复审；",
                        },
                        {
                            id: 6,
                            text: "公示；",
                        },
                        {
                            id: 7,
                            text: "确定人选。",
                        },
                    ],
                    boxHeight: "height:5.72rem;padding-left:0.5rem",
                },
                {
                    id: 31,
                    title: require("../assets/imgs/10/part4-3.png"),
                    content: [
                        {
                            id: 1,
                            text: "确定推荐名额；",
                        },
                        {
                            id: 2,
                            text: "区（市）县推荐；",
                        },
                        {
                            id: 3,
                            text: "市级部门联审；",
                        },
                        {
                            id: 4,
                            text: "产业链牵头市级部门初审；",
                        },
                        {
                            id: 5,
                            text: "市委组织部复审；",
                        },
                        {
                            id: 6,
                            text: "公示；",
                        },
                        {
                            id: 7,
                            text: "确定人选。",
                        },
                    ],
                    boxHeight:
                        "height:5.68rem;padding-left:0.5rem;margin-bottom: 0;",
                },
            ],
            phoneNumber: [
                {
                    number:'028-61886095',
                    height:'0.55rem'
                },
                {
                    number:'028-61881595',
                    height:'0.94rem'
                },
                {
                    number:'028-61888770',
                    height:'0.94rem'
                },
                {
                    number:'028-61881637',
                    height:'0.94rem'
                },
                {
                    number:'028-61888625',
                    height:'0.94rem'
                },
                {
                    number:'028-61884670',
                    height:'1.27rem'
                },
                {
                    number:'028-61883970',
                    height:'0.94rem'
                },
                {
                    number:'028-61884659',
                    height:'0.94rem'
                },
                {
                    number:'028-61884324',
                    height:'0.61rem'
                },
                {
                    number:'028-61881611',
                    height:'0.94rem'
                },
                {
                    number:'028-61881611',
                    height:'0.94rem'
                },
                {
                    number:'028-61881611',
                    height:'0.94rem'
                },
                {
                    number:'028-61888773',
                    height:'0.94rem'
                },
                {
                    number:'028-61881635',
                    height:'0.94rem'
                },
                {
                    number:'028-61884026',
                    height:'0.61rem'
                },
                {
                    number:'028-61886335',
                    height:'0.61rem'
                },
                {
                    number:'028-61886335',
                    height:'0.61rem'
                },
                {
                    number:'028-61881642',
                    height:'0.94rem'
                },
                {
                    number:'028-61881605',
                    height:'0.94rem'
                },
                {
                    number:'028-61881605',
                    height:'0.94rem'
                },
                {
                    number:'028-61881957',
                    height:'0.61rem'
                },
                {
                    number:'028-61887273',
                    height:'0.61rem'
                },
                {
                    number:'028-61880569',
                    height:'0.94rem'
                },
                {
                    number:'028-61887838',
                    height:'0.61rem'
                },
                {
                    number:'028-61885363',
                    height:'0.61rem'
                },
                {
                    number:'028-61885319',
                    height:'0.61rem'
                },
                {
                    number:'028-61883724',
                    height:'0.94rem'
                },
                {
                    number:'028-61883525',
                    height:'0.61rem'
                },
                {
                    number:'028-61883525',
                    height:'0.61rem'
                },
            ],
        };
    },
    components: {
        call,
    },
    created() { },
    mounted() { },
    computed: {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.craft {
    background: #0839b7;
    overflow: hidden;
    padding: 0.24rem 0.12rem;
    padding-bottom: 1.65rem;
    box-sizing: border-box;
    width: 100vw;
    height: 100vh;
    overflow-y: auto;

    .part-title {
        font-size: 0.34rem;
        // //font-family:: PingFang SC-Bold, PingFang SC;
        font-weight: bold;
        color: #333333;
        position: relative;

        &::before {
            position: absolute;
            content: "";
            width: 0.28rem;
            height: 0.28rem;
            border-radius: 50%;
            background: none;
            border: 0.06rem solid #ff6d60;
            box-sizing: border-box;
            top: 0.08rem;
            left: -0.2rem;
        }
    }

    .part-text {
        font-size: 0.26rem;
        // //font-family:: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #4e4e4e;
        line-height: 0.44rem;
        text-align: left;
    }

    .part-one {
        height: 7.5rem;

        width: 7.5rem;
        margin: 0 auto;

        .base-title {
            width: 7.26rem;
            height: 5.6rem;
            background: url(../assets/imgs/10/base-title.png);
            background-size: 100% 100%;
            position: relative;

            .part-one-content {
                width: 6.85rem;
                // height: 5.2rem;
                padding-bottom: 0.35rem;
                background: #ffffff;
                border-radius: 10px;
                position: absolute;
                top: 4.02rem;
                left: 0.22rem;
                padding-left: 0.36rem;
                padding-right: 0.37rem;
                box-sizing: border-box;

                .part-one-title-img {
                    position: absolute;
                    top: -0.32rem;
                    left: 0;
                    width: 6.86rem;
                    height: 1.12rem;
                }

                .part-one-text {
                    margin-top: 0.9rem;
                }
            }
        }
    }

    .part-two-title-img {
        width: 7.03rem;
        height: 1.37rem;
        top: 0;
        left: -0.18rem;
        position: absolute;
    }

    .part-two {
        width: 6.85rem;
        padding-bottom: 0.45rem;
        background: #fff;
        border-radius: 10px;
        padding-left: 0.53rem;
        padding-right: 0.3rem;
        box-sizing: border-box;
        display: block;
        margin: 0 auto;
        margin-top: 0.22rem;
        position: relative;
        padding-top: 1.5rem;
    }

    .part-three {
        width: 6.85rem;
        background: #e8eeff;
        border-radius: 10px;
        margin: 0 auto;
        margin-top: 0.22rem;

        box-sizing: border-box;
        position: relative;
        padding: 1.84rem 0.25rem 0 0.25rem;
        padding-bottom: 0.65rem;

        .mark {
            width: 100%;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            font-size: 0.2rem;
            bottom: 1%;
            z-index: 9999;
            color: #000;
        }

        .part-four-title {
            text-align: left;
            margin-left: 0.35rem;

            &::before {
                position: absolute;
                content: "";
                width: 0.28rem;
                height: 0.28rem;
                border-radius: 50%;
                background: none;
                border: 0.06rem solid #ff6d60;
                box-sizing: border-box;
                top: 0.08rem;
                left: -0.38rem;
            }
        }

        .part-three-items {
            width: 6.35rem;
            // height: 1.45rem;
            background: #ffffff;
            border-radius: 10px;
            padding-top: 0.68rem;
            padding-left: 0.31rem;
            padding-right: 0.31rem;
            box-sizing: border-box;
            position: relative;
            margin-bottom: 0.52rem;
            padding-bottom: 0.35rem;

            .part-three-items-text {
                font-size: 0.26rem;
                // //font-family:: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #4e4e4e;
                text-align: left;
            }

            .part-three-items-img {
                position: absolute;
                width: 2.98rem;
                height: 0.67rem;
                left: 50%;
                transform: translateX(-50%);
                top: -0.32rem;
            }

            .part-three-plus {
                width: 4.5rem;
                height: 0.67rem;
            }

            .part-four-texts {
                box-sizing: border-box;
                position: relative;
                font-size: 0.26rem;
                padding-left: 0.33rem;
                // //font-family:: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #4e4e4e;
                line-height: 0.44rem;
                text-align: left;
                margin-bottom: 0.22rem;

                .part-two-dot {
                    position: absolute;
                    top: 0.05rem;

                    left: -0.18rem;
                    width: 0.36rem;
                    height: 0.36rem;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    color: #fff;
                    font-size: 0.26rem;
                    background: #739bfe;
                    border-radius: 50%;

                    &::after {
                        position: absolute;
                        content: "";
                        width: 0;
                        box-sizing: border-box;
                        border-left: 0.02rem dashed #739bfe;
                        height: 0.3rem;
                        top: 0.36rem;
                    }
                }

                .part-two-dot2 {
                    position: absolute;
                    top: 0.05rem;
                    left: -0.18rem;
                    width: 0.36rem;
                    height: 0.36rem;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    color: #fff;
                    font-size: 0.26rem;
                    background: #739bfe;
                    border-radius: 50%;
                }
            }
        }
    }

    .part-five {
        width: 6.85rem;
        background: #fff;
        margin: 0 auto;
        margin-top: 0.32rem;
        border-radius: 10px;
        box-sizing: border-box;
        padding: 0.25rem;
        padding-top: 0.35rem;

        .code {
            width: 6.2rem;
            height: 2.09rem;
            display: inline-flex;
            justify-content: center;
            align-items: center;

            .scan-code {
                width: 1.94rem;
                height: 1.94rem;
            }
        }
    }

    .call {
        width: 6.85rem;
        height: 26.44rem;
        margin: 0 auto;
        margin-top: 0.22rem;
        border-radius: 10px;
        background: url(../assets/imgs/10/part-five.png);
        background-size: 100% 100%;
        position: relative;
        box-sizing: border-box;
        padding-top: 2.58rem;
        padding-left: 4.08rem;

        .part-five-items {
            width: 2.77rem;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 0.26rem;
            font-weight: 500;
        }

        .mark {
            width: 100%;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            font-size: 0.2rem;
            top: 4.3%;
            color: #000;
        }
    }
}
</style>
